import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Flex, HStack, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { CodeStatuses, CodeTags } from '../../../../../../../../../../../constants/codes';
import ItemCodesPopover from '../components/ItemCodesPopover';

const CodeCell = ({ value: codes = [], row, hidePopover = false }) => {
  const { companyId } = useParams();

  const filteredCodes = codes
    .map(code => ({ ...code, status: code.status || CodeStatuses.Applied }))
    .filter(code => [
      CodeStatuses.Applied,
      CodeStatuses.Suggested,
      CodeStatuses.RemovalSuggested,
      CodeStatuses.Waived,
      CodeStatuses.Inquiring
    ].includes(code.status));

  return (
    <Flex alignItems="center" justifyContent="center">
      <HStack spacing={0} width="80px">
        {filteredCodes.length
          ? (
            <>
              {filteredCodes.map((code, index) => {
                if (index > 2) return '';
                if (index === 2) {
                  return (
                    <Box as="span" color="greyScale.900" fontSize="sm">
                      ...
                    </Box>
                  );
                }

                return CodeTags[code.status](code.letter);
              })}
            </>
          )
          : (
            <Text color="greyScale.900">
              None
            </Text>
          )}
      </HStack>
      {!hidePopover && (
        <ItemCodesPopover
          codes={codes}
          companyId={companyId}
          itemId={row.original.id}
        />
      )}
    </Flex>
  );
};

CodeCell.propTypes = {
  value: PropTypes.arrayOf(PropTypes.shape({ letter: PropTypes.string })),
  row: PropTypes.shape({ original: PropTypes.shape({ id: PropTypes.number }) }),
  hidePopover: PropTypes.bool
};

export default CodeCell;
